import { Injectable } from '@angular/core';
import {
  LotsListQueryVariables,
  LotStatusEnum,
} from 'src/app/modules/graphql/service/graphql-cars-default-service';
import { getTypeSort } from '../../../../../const';
import { frameVariants } from 'src/app/utils/frame.util';

@Injectable()
export class AutoLotsListFilterService {
  private inclusionFilterFields = {
    frame: 'modelTypeEn',
    score: 'scoresEn',
    auction: 'auctRef',
    color: 'colorEn',
    transmission: 'transmissionEn',
    date: 'date',
    result: 'result',
  };

  buildVariables(params: any, page: number, pageSize: number): LotsListQueryVariables {
    return {
      first: pageSize,
      offset: (page - 1) * pageSize,
      filter: this.buildFilter(params),
      sort: this.buildSort(params),
    };
  }

  private buildSort(params: any): LotsListQueryVariables['sort'] {
    const sort = {} as LotsListQueryVariables['sort'];

    if (params.sort && params.sortType) {
      sort[params.sort] = {
        direction: params.sortType,
      };
    }

    return sort;
  }

  private buildFilter(params: any): LotsListQueryVariables['filter'] {
    const inclusionFilter = [];

    Object.keys(this.inclusionFilterFields).forEach((key) => {
      if (params[key] && params[key].length > 0) {
        inclusionFilter.push({
          fieldName: this.inclusionFilterFields[key],
          eq:
            key === 'frame'
              ? [...new Set([].concat(params[key]).flatMap(frameVariants))]
              : [].concat(params[key]),
        });
      }
    });

    return {
      companyRef: {
        eq: params.company,
      },
      modelNameRef: {
        eq: params.model,
      },
      truckRef: {
        eq: params.truck,
      },
      year: {
        gte: +params.yearFrom,
        lte: +params.yearTo,
      },
      mileage: {
        gte: +params.mileageFrom ? +params.mileageFrom : null,
        lte: +params.mileageTo ? +params.mileageTo : null,
      },
      engineVolume: {
        gte: +params.engineVolumeFrom,
        lte: +params.engineVolumeTo,
      },
      productionDate: {
        gte: params.productionDateFrom,
        lte: params.productionDateTo,
      },
      bid: {
        eq: params.bid,
      },
      inclusion:
        inclusionFilter.length > 0
          ? {
              columns: inclusionFilter,
            }
          : undefined,
      datetime: {
        gt: params.datetime,
      },
      bidsCount: params.hasBids === 'true' ? { gte: 1 } : undefined,
      savedLotStatus:
        params.hasNegotiations === 'true' ? { eq: LotStatusEnum.Negotiations } : undefined,
      translationsCount: params.hasTranslations === 'true' ? { gte: 1 } : undefined,
      modelGradeEn: {
        eq: params.modelGrade,
      },
      leftDrive: {
        eq: params.drive ? params.drive === 'left' : undefined,
      },
    };
  }

  buildSortQueryParams(sort: { key: string; value: string }): { sort: string; sortType: string } {
    return {
      sort: sort.key,
      sortType: getTypeSort(sort.value),
    };
  }
}
